export default __webpack_public_path__ + "static/media/trophy1.46fff330.svg";